import { required, shape, items, concatFailure, when, atLeastOne, fromParent } from '@totalsoft/pure-validations';
import { filterConditionContainsConditionNumbers } from '../../utils/customValidators';

export const documentTemplateValidator = shape({
  templateName: required,
  templateCode: required,
  documentTypeId: required,
  localDiskFileName: required,
  exportType: required,
  outputType: required,
  filterCondition: fromParent(parent => filterConditionContainsConditionNumbers(parent.numberConditions))
});

export const signatureBookmarksValidator = concatFailure(
  items(
    shape({
      name: required,
      signatureBookmarkActors: [atLeastOne] |> concatFailure
    })
  )
);

export const documentTemplateXoptionBookmarkValidator = concatFailure(
  items(
    shape({
      bookmarkName: required,
      dataSource: required
    })
  )
);

export const documentTemplateXSignaturesValidator = shape({
  documentTemplateXSignatures: fromParent(parent => [atLeastOne, required |> items] |> concatFailure |> when(parent.needsSigning))
});
